import React, { Component } from 'react'
import { Trans, withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { compose } from 'redux'
import { Field, Form, formValueSelector, reduxForm } from 'redux-form/dist/redux-form'
import InputField from '../../formFields/InputField'
import SelectSpecialityField from '../../formFields/SelectSpecialityField'
import { uploadImageComponent } from '../../formFields/uploadImageComponent'
import Consultations from '@services/Consultations'
import history from '@services/History'
import CheckboxField from '@modules/formFields/ChecboxField'

class CompanyForm extends Component {
  submit = (values) => {
    if (!this.props.editable) return
    let requestBody

    if (this.props.match.path.includes('specialities')) {
      requestBody = {
        speciality_ids: values.specialities && values.specialities.map((sp) => sp.id),
      }

      return Consultations.company
        .updateSpecialities(this.props.initialValues.id, requestBody)
        .then(() => history.push('/companies'))
        .catch((e) => console.error(e.message))
    }

    requestBody = {
      ...values,
      nps_active: values.nps_active || false,
      nps_time_ago_to_check_messages:
        values.nps_time_ago_to_check_messages && parseInt(values.nps_time_ago_to_check_messages),
      nps_delay: values.nps_delay && parseInt(values.nps_delay),
      nps_message_threshold: values.nps_message_threshold && parseInt(values.nps_message_threshold),
      nps_delivery: values.nps_delivery && parseInt(values.nps_delivery),
      nps_quarantine: values.nps_quarantine && parseInt(values.nps_quarantine),
      anonymous_status: values.anonymous_status && parseInt(values.anonymous_status),
      cache_sync_timeout: Number(values.cache_sync_timeout),
      sync_customers: values.sync_customers || false,
    }

    if (this.props.initialValues.id) {
      return Consultations.company
        .update(this.props.initialValues.id, requestBody)
        .then(() => history.push('/companies'))
        .catch((e) => console.error(e))
    }
  }

  render() {
    const { handleSubmit, submitting, t, editable, match } = this.props
    return (
      <Form onSubmit={handleSubmit(this.submit)}>
        {!match.path.includes('specialities') && (
          <>
            <div className="md-form full">
              <div className="double-box">
                <div>
                  <Field
                    name="name"
                    component={InputField}
                    placeholder={t('Nombre')}
                    label={t('Nombre')}
                    disabled={editable}
                  />

                  <div className="md-field">
                    <label>Derivaciones</label>
                    <div className="flex-check">
                      <Field
                        name="has_medical_derivations"
                        type="checkbox"
                        component="input"
                        className="check-box"
                        disabled={!editable}
                      />
                    </div>
                  </div>
                  <div className="md-field">
                    <label>Reportes</label>
                    <div className="flex-check">
                      <Field
                        name="has_medical_reports"
                        type="checkbox"
                        component="input"
                        className="check-box"
                        disabled={!editable}
                      />
                    </div>
                  </div>
                  <div className="md-field">
                    <label>Prescipciones</label>
                    <div className="flex-check">
                      <Field
                        name="has_prescription"
                        type="checkbox"
                        component="input"
                        className="check-box"
                        disabled={!editable}
                      />
                    </div>
                  </div>
                  <div className="md-field">
                    <label>Videollamada pool</label>
                    <div className="flex-check">
                      <Field
                        name="has_video_call"
                        type="checkbox"
                        component="input"
                        className="check-box"
                        disabled={!editable}
                      />
                    </div>
                  </div>
                  <div className="md-field">
                    <label>Videollamada pool</label>
                    <div className="flex-check">
                      <Field
                        name="has_video_call_1to1"
                        type="checkbox"
                        component="input"
                        className="check-box"
                        disabled={!editable}
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <Field name={'logo'} component={uploadImageComponent} label={t('logo')} disabled={!editable} />
                  <Field name={'icon'} component={uploadImageComponent} label={t('icon')} disabled={!editable} />
                </div>
              </div>
            </div>
            <div className="md-form full">
              <label>{t('anonymousAllowed')}</label>
              <Field
                name="anonymous_allowed"
                component={CheckboxField}
                className="check-box"
                disabled={!editable}
                label="Texto usuario anonimo allowed"
              />
              <Field
                name="professional_list"
                component={InputField}
                placeholder={'Lista de Profesionales'}
                label={'Lista de Profesionales'}
                multi
                disabled={!editable}
              />
              <Field
                name="integration_type"
                component={InputField}
                placeholder={'Tipo de Integración'}
                label={'Tipo de Integración'}
                disabled={!editable}
              />
              <Field
                name="token_type"
                component={InputField}
                placeholder={'Tipo de Token'}
                label={'Tipo de Token'}
                disabled={!editable}
              />
              <Field
                name="login_type"
                component={InputField}
                placeholder={'Tipo de Login'}
                label={'Tipo de Login'}
                disabled={!editable}
              />
              <Field
                name="integration_mode"
                component={InputField}
                placeholder={'Modo de integración'}
                label={'Modo de integración'}
                disabled={!editable}
              />
            </div>
            <div className="md-form full">
              <label>{t('npsActive')}</label>
              <Field
                name="nps_active"
                component={CheckboxField}
                className="check-box"
                disabled={!editable}
                label="NPS Activo texto"
              />

              <Field
                name="nps_title"
                component={InputField}
                placeholder={t('npsTitle')}
                label={t('npsTitle')}
                disabled={!editable}
              />
              <Field
                name="nps_url"
                component={InputField}
                placeholder={t('npsUrl')}
                label={t('npsUrl')}
                disabled={!editable}
              />
              <Field
                name="nps_time_ago_to_check_messages"
                component={InputField}
                placeholder={t('npsTime')}
                label={t('npsTime')}
                type="number"
                disabled={!editable}
              />
              <Field
                name="nps_delay"
                component={InputField}
                placeholder={t('npsDelay')}
                label={t('npsDelay')}
                type="number"
                disabled={!editable}
              />
              <Field
                name="nps_delivery"
                component={InputField}
                placeholder={t('npsDelivery')}
                label={t('npsDelivery')}
                type="number"
                disabled={!editable}
              />
              <Field
                name="nps_message_threshold"
                component={InputField}
                placeholder={t('npsMessageThreshold')}
                label={t('npsMessageThreshold')}
                type="number"
                disabled={!editable}
              />
              <Field
                name="nps_quarantine"
                component={InputField}
                placeholder={t('npsQuarantine')}
                label={t('npsQuarantine')}
                type="number"
                disabled={!editable}
              />
            </div>
            <div className="md-form full">
              <Field
                name="support_email"
                component={InputField}
                placeholder={t('supportEmail')}
                label={t('supportEmail')}
                disabled={!editable}
                type="email"
              />
              <Field
                name="sms_sender_name"
                component={InputField}
                placeholder={t('smsSenderName')}
                label={t('smsSenderName')}
                disabled={!editable}
              />

              <Field
                name="push_webhook"
                component={InputField}
                placeholder={t('pushWebhook')}
                label={t('pushWebhook')}
                disabled={!editable}
              />
              <Field
                name="fcm_server_key"
                component={InputField}
                placeholder={t('fcmServerKey')}
                label={t('fcmServerKey')}
                disabled={!editable}
              />
              <Field
                name="fcm_sender_id"
                component={InputField}
                placeholder={t('fcmSenderId')}
                label={t('fcmSenderId')}
                disabled={!editable}
              />

              <Field
                name="integration_url"
                component={InputField}
                placeholder={t('integrationUrl')}
                label={t('integrationUrl')}
                disabled={!editable}
              />
              <Field
                name="bundle_id_android"
                component={InputField}
                placeholder={'bundle id android'}
                label={'bundle id android'}
                disabled={!editable}
              />
              <Field
                name="bundle_id_ios"
                component={InputField}
                placeholder={'bundle id ios'}
                label={'bundle id ios'}
                disabled={!editable}
              />

              <Field
                name="requests_per_second"
                component={InputField}
                placeholder={'Peticiones por segundo'}
                label={'Peticiones por segundo'}
                type="number"
                disabled={!editable}
              />

              <Field
                name="billing_strategy"
                component={InputField}
                placeholder={'Estrategia billing'}
                label={'Estrategia billing'}
                disabled={!editable}
              />

              <Field
                name="mail_from_name"
                component={InputField}
                placeholder={'Mail from name'}
                label={'Mail from name'}
                disabled={!editable}
                type="email"
              />
              <Field
                name="anonymous_status"
                component={InputField}
                placeholder={'Status Anónimo'}
                label={'Status Anónimo'}
                type="number"
                disabled={!editable}
              />

              <Field
                label={'Cache sync timeout'}
                name="cache_sync_timeout"
                component={InputField}
                disabled={!editable}
                type="number"
              />
              <label>Sync Customers</label>
              <Field name="sync_customers" component={CheckboxField} className="check-box" disabled={!editable} />
            </div>
          </>
        )}

        {match.path.includes('specialities') && (
          <Field
            multi
            name="specialities"
            component={SelectSpecialityField}
            placeholder={t('Especialidades')}
            label={<Trans>Especialidades</Trans>}
          />
        )}
        {editable && (
          <button type="submit" className="btn btn-primary" disabled={submitting}>
            <Trans>Guardar</Trans>
          </button>
        )}
      </Form>
    )
  }
}

const validate = (values, props) => {
  const { t, match } = props
  const errors = {}
  if (match.path.includes('specialities')) return errors
  if (!values.name) {
    errors.name = t('Campo requerido')
  }
  if (!values.integration_type) {
    errors.integration_type = t('Campo requerido')
  }
  if (values.anonymous_allowed === null) {
    errors.anonymous_allowed = t('Campo requerido')
  }
  return errors
}

const mapStateToProps = (state) => ({
  selectedType: formValueSelector('company')(state, 'type'),
})

export default compose(
  withTranslation(),
  withRouter,
  reduxForm({ form: 'company', validate }),
  connect(mapStateToProps)
)(CompanyForm)
